var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-bar"},[_c('img',{staticStyle:{"width":"100%","height":"50px"},attrs:{"src":require("@/assets/img/icon-red-bar.png")}}),_c('div',{staticClass:"main"},[_c('el-image',{staticClass:"main-img",attrs:{"src":require('@/assets/img/icon-bar-point.png')}}),_c('div',{staticClass:"main-title1"},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }